// Client logos using actual PNG images from public/images folder
import ResponsiveImage from '../ResponsiveImage';

export const ClientsLogo = ({ src = "", alt = "", size = 80, className = "" }) => (
    <ResponsiveImage
        src={src}
        alt={alt}
        width={size}
        height={size}
        className={className}
        style={{ objectFit: 'contain' }}
    />
);
